import React from 'react';
import classnames from 'classnames';

import { Width } from './types';

import './WpPageUtilityNavBar.scss';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  width?: Width;
}

const WpPageUtilityNavBar: React.FC<Props> = ({ children, className, wrapperClassName, width }: Props) => {
  const baseClassName = 'WpPageUtilityNavBar';
  const classes = classnames(baseClassName, `${baseClassName}--${width}`, {
    [wrapperClassName]: Boolean(wrapperClassName),
  });

  return (
    <div className={classes}>
      <div className={`${baseClassName}__content ${baseClassName}__content--${width} ${className}`}>{children}</div>
    </div>
  );
};

export default WpPageUtilityNavBar;
